import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'pcln-design-system'
import { ChevronUp, ChevronDown } from 'pcln-icons'
import IconSet from './IconSet.js'
import { hasFailedRenderConditions } from '../../utils/hasFailedRenderConditions'

const StyledLink = styled(Link)`
  align-items: center;
  display: flex;
  font-weight: ${(props) => (props.bold === 'true' ? '700' : props.fontWeight)};
`

const ICONS = { ChevronUp, ChevronDown }

function NavLink({
  className,
  color,
  dropdownIconName,
  fontWeight,
  href,
  iconColor,
  iconName,
  label,
  renderConditions,
  target,
  variation,
  onClick,
  ...props
}) {
  const Icon = ICONS[dropdownIconName]
  const linkHasFailedRenderConditions = renderConditions
    ? hasFailedRenderConditions({ props, renderConditions })
    : false

  if (linkHasFailedRenderConditions) {
    return null
  }

  return (
    <StyledLink
      className={className}
      color={color}
      data-testid='nav-link'
      fontWeight={variation === 'fill' ? 'bold' : fontWeight}
      href={href}
      key={label}
      label={label}
      rel='noopener'
      target={target}
      variation={variation}
      onClick={onClick}
      {...props}
    >
      {iconName && (
        <IconSet color={iconColor || color} data-testid='nav-link-icon' iconName={iconName} mr={3} />
      )}
      {label}
      {dropdownIconName && <Icon title={dropdownIconName} size={24} />}
    </StyledLink>
  )
}

NavLink.displayName = 'NavLink'

NavLink.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  dropdownIconName: PropTypes.string,
  fontWeight: PropTypes.string,
  href: PropTypes.string,
  iconColor: PropTypes.string,
  iconName: PropTypes.string,
  label: PropTypes.string.isRequired,
  renderConditions: PropTypes.array,
  target: PropTypes.string,
  variation: PropTypes.string,
  onClick: PropTypes.func,
}

NavLink.defaultProps = {
  className: '',
}

export default memo(NavLink)
